module.exports = __webpack_public_path__ + "static/media/irishlife.c403aae5.png";